import React from "react";
import { COMPANY_LOGO, COMPANY_SHORT_NAME } from "../utils/company.js";

const BrandLogo = ({ className = "w-9 h-9", alt }) => (
  <img
    src={COMPANY_LOGO}
    alt={alt ?? COMPANY_SHORT_NAME}
    className={`object-contain select-none shrink-0 ${className}`}
    draggable={false}
  />
);

export default BrandLogo;
